import 'react-image-crop/dist/ReactCrop.css';

import { Badge, ErrorMessage, Spinner } from '../../../../widgets';

import { FC } from 'react';
import { FetchStatus } from '../../../../base/types';
import { IControlAttributes } from '../../../../base/models';
import { WebcamImage } from './WebcamImage';
import { useWebcamImageProperties } from './WebcamImageProperties';

export const DraftWebcamImageComponent: FC<IControlAttributes> = ({
  className, props
}) => {
  const { status, properties, error } = useWebcamImageProperties(props);

  switch (status) {
    case FetchStatus.Idle: return <></>
    case FetchStatus.Loading: return <Spinner show={true} />
    case FetchStatus.Error: return <ErrorMessage message={error} />
  }

  return <div className={"inline-block position-relative"}>
    <Badge
      className={"position-absolute top-0 end-0 text-nowrap fs-9 rounded-0"}
      badgeStyle="primary">
      Screenshot
    </Badge>
    <WebcamImage {...properties} className={className} />
  </div>
};